import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAppContext } from '../contexts/AppContext';

export default function ProtectedRoute() {
  const { appState } = useAppContext();

  const isAuthenticated = Boolean(
    appState?.isAuthenticated && appState?.accessToken && appState?.refreshToken
  );

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  return <Outlet />;
}
